module.exports = __webpack_public_path__ + "img/rep-jenna.eec398b2.png";